import React from "react";
import {GroupAdd, InsertChartOutlined, Router, SimCardOutlined, TapAndPlay} from "@material-ui/icons";
import PhoneAndroidOutlinedIcon from "@material-ui/icons/PhoneAndroidOutlined";
import LibraryAddCheckOutlinedIcon from "@material-ui/icons/LibraryAddCheckOutlined";
import inventoryIcon from "../../../../assets/images/inventory_icon.svg";
import ShareOutlinedIcon from "@material-ui/icons/ShareOutlined";
import EventNoteIcon from "@material-ui/icons/EventNote";
import MenuBookRoundedIcon from "@material-ui/icons/MenuBookRounded";
import HomeIcon from "@material-ui/icons/Home";
import contractIcon from "../../../../assets/images/icon-content-contract-24-px.svg";
import {routePaths} from "../../../../shared/utils/constants/routePaths";
import SimCardIcon from '@material-ui/icons/SimCard';

export const getDrawerListItems = (typeUser, showDigitalContract, isConsipCustomer) => [
    {
        text: "Home",
        icon: <HomeIcon/>,
        to: "/home"
    },
    {
        text: "Rete Fissa",
        icon: <Router/>,
        to: "/rete-fissa"
    },
    {
        text: "Rete mobile",
        icon: <TapAndPlay/>,
        to: routePaths.MOBILE,
        subItems: [
            {
                text: "Report",
                icon: <InsertChartOutlined/>,
                to: routePaths.REPORT,
                roles: "B"
            },
            {
                text: "SIM",
                icon: <SimCardOutlined/>,
                to: routePaths.SIM,
                roles: "A"
            },
            {
                text: "Device",
                icon: <PhoneAndroidOutlinedIcon style={{transform: "rotate(180deg)"}}/>,
                to: routePaths.DEVICE,
                roles: "A"
            },
            {
                text: "Richieste e assistenza",
                icon: <LibraryAddCheckOutlinedIcon/>,
                to: routePaths.ASSISTENZA,
                roles: "C"
            },
            {
                text: "Ordini di spedizione",
                icon: <img src={inventoryIcon} alt="inventory-icon" style={{width: "25px"}}/>,
                to: routePaths.ORDINI_DI_SPEDIZIONE,
                roles: "A"
            },
            {
                text: "Extra Share",
                icon: <ShareOutlinedIcon/>,
                to: routePaths.EXTRA_SHARE,
                roles: ""
            },
            {
                text: "Soglie & Eventi",
                icon: <EventNoteIcon/>,
                to: routePaths.THRESHOLD_EVENTS,
                roles: ""
            },
            ...showDigitalContract ? [{
                text: "Contratto digitale",
                icon: <img src={contractIcon} alt="contract-icon" style={{width: "25px"}}/>,
                to: routePaths.CONTRATTO_DIGITALE,
                roles: ""
            }] : [],
            ...typeUser === "operator" ? [{
                text: "Manuale",
                icon: <MenuBookRoundedIcon/>,
                to: routePaths.MANUALE,
                roles: "A"
            }] : [],
            ...isConsipCustomer ?
                [{
                    text: "Ordini CONSIP TM9",
                    icon: <img src={contractIcon} alt="contract-icon" style={{width: "25px"}}/>,
                    to: routePaths.ORDINI_CONSIP_TM9,
                    roles: ""
                }] : [],
            {
                text: "Monitoring eSim",
                icon: <SimCardIcon />,
                to: routePaths.ESIM,
                roles: ""
            },
        ]
    },
    // {
    //     text: "Fatture",
    //     icon: <DescriptionOutlinedIcon/>,
    //     to: "/fatture"
    // },
    {
        text: "Gestione Utenti",
        icon: <GroupAdd/>,
        to: "/gestione-utenti"
    }
]
